import { Paginator } from "primereact/paginator";
import { parse, stringify } from "query-string";
import { useState } from "react";
import { useHistory } from "react-router-dom";

import DownloadDetail from "../../images/download_detail_white.svg";
import { dateToRegularFormat } from "../../utils/dates";
import { ITEMS_PER_PAGE } from "../../utils/valueStaticConstants";
import { GrayDiv } from "../AdminAppointmentConfiguration/AdminAppointmentConfigurationStyled";
import AdminComplaintsDetailSidebar, {
  MainButtonReclamos,
} from "../AdminComplaintsDetailSidebar/AdminComplaintsDetailSidebar";
import { SubtitleDiv } from "../AdminDocumentManagement/AdminDocumentManagementSharedStyles";
import { InvoicesContainer } from "../AdminPaymentValidationTable/CommonTable";
import { Row } from "../DocumentManagement/DocumentManagementSharedStyles";
import { TableHeader } from "../Invoices/InvoicesStyles";
import PaymentLoader from "../PaymentLoader/PaymentLoader";
import StandaloneMessage from "../StandaloneMessage/StandaloneMessage";
import StatusTag from "../StatusTag/StatusTag";
import {
  DivFlexButton,
  DivFlexComplaint,
  FlexJustifyBetween,
} from "./AdminComplaintsTableStyles";
import { DownloadReportModal } from "./DownloadReportModal";

export const AdminComplaintsTable = (props) => {
  const { loadComplains } = props;

  const [showModal, updateShowModal] = useState(false);
  const history = useHistory();

  const toggleModal = () => {
    updateShowModal(!showModal);
  };

  const gridTemplateColumns = "repeat(6, 1fr)";

  const [modalReclamos, setModalReclamos] = useState(false);
  const handleClose = () => setModalReclamos(!modalReclamos);
  const [selectedComplaint, updateSelectedComplaint] = useState(null);
  const handleClick = (elem) => {
    updateSelectedComplaint(elem);
    updateShowModal(true);
  };
  return (
    <div>
      {loadComplains.isError && (
        <div>
          Algo salió mal
          <button
            type="button"
            onClick={() => {
              loadComplains.retry();
            }}
          >
            Reintentar
          </button>
        </div>
      )}
      {loadComplains.isSuccess && loadComplains.data.docs.length === 0 && (
        <StandaloneMessage>No hay resultados que mostrar</StandaloneMessage>
      )}
      {loadComplains.status === "PROCESSING" && (
        <>
          <PaymentLoader numItems={ITEMS_PER_PAGE} />
        </>
      )}
      <div>
        <>
          <InvoicesContainer gridTemplateColumns={gridTemplateColumns}>
            {loadComplains.isSuccess && loadComplains.data.docs.length > 0 && (
              <TableHeader className="item-container">
                <div
                  className="left-aligned-header"
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    marginLeft: "2rem",
                  }}
                >
                  NÚMERO / CLIENTE / FECHA DE INGRESO
                </div>
                <div>ÁREA</div>
                <div>PROCESO</div>
                <div>MOTIVO</div>
                <div>ESTADO</div>
                <div>FECHA MÁXIMA</div>
              </TableHeader>
            )}
            {loadComplains.isSuccess &&
              loadComplains.data.docs.map((elem) => {
                return (
                  <Row
                    className="item-container"
                    key={elem.complaintId}
                    onClick={() => handleClick(elem)}
                  >
                    <div className="attribute" style={{ display: "contents" }}>
                      <div className="titles">
                        NÚMERO / CLIENTE / FECHA DE INGRESO
                      </div>
                      <div>
                        <SubtitleDiv>{elem.complaintId}</SubtitleDiv>
                        <div>{elem.client.name}</div>
                        <GrayDiv>
                          {dateToRegularFormat(elem.registerDate.split("T")[0])}
                        </GrayDiv>
                      </div>
                    </div>

                    <div className="attribute">
                      <div className="titles">ÁREA</div>
                      <div>{elem.area}</div>
                    </div>
                    <div className="attribute">
                      <div className="titles">PROCESO</div>
                      <div>{elem.process}</div>
                    </div>
                    <div className="attribute">
                      <div className="titles">MOTIVO</div>
                      <div>{elem.reason}</div>
                    </div>
                    <div className="attribute">
                      <div className="titles">ESTADO</div>
                      <div>
                        <StatusTag status={elem.status} />
                      </div>
                    </div>
                    <div className="attribute">
                      <div className="titles">FECHA MÁXIMA</div>
                      <div>
                        {elem.maxDate === null
                          ? "-"
                          : dateToRegularFormat(elem.maxDate.split("T")[0])}
                      </div>
                    </div>
                  </Row>
                );
              })}
          </InvoicesContainer>
          {loadComplains.status === "SUCCESS" && (
            <>
              {loadComplains.data.count > 0 && (
                <div className="flex-paginator">
                  <Paginator
                    first={
                      (loadComplains.params.page - 1) *
                      loadComplains.data.totalPages
                    }
                    rows={loadComplains.data.totalPages}
                    totalRecords={loadComplains.data.count}
                    onPageChange={(e) => {
                      const targetPage =
                        e.first / loadComplains.data.totalPages;
                      const pathname = history.location.pathname;
                      const parsedParams = parse(history.location.search);
                      const stringifiedParams = stringify({
                        ...parsedParams,
                        page: targetPage + 1,
                      });
                      history.push(`${pathname}?${stringifiedParams}`);
                    }}
                  />
                </div>
              )}
            </>
          )}
          <FlexJustifyBetween>
            {loadComplains.status === "SUCCESS" && (
              <>
                <DivFlexComplaint>
                  {loadComplains.data.totalCount > 0 && (
                    <>
                      <div className="flex-paginator">
                        <Paginator
                          first={
                            (loadComplains.params.page - 1) *
                            loadComplains.data.limit
                          }
                          rows={loadComplains.data.limit}
                          totalRecords={loadComplains.data.totalCount}
                          onPageChange={(e) => {
                            const targetPage =
                              e.first / loadComplains.data.limit;
                            const pathname = history.location.pathname;
                            const parsedParams = parse(history.location.search);
                            const stringifiedParams = stringify({
                              ...parsedParams,
                              page: targetPage + 1,
                            });
                            history.push(`${pathname}?${stringifiedParams}`);
                          }}
                        />
                      </div>
                      <DivFlexButton>
                        <MainButtonReclamos
                          className="buttom-download"
                          onClick={() => {
                            setModalReclamos(true);
                          }}
                        >
                          <div className="flex-item-center">
                            <div style={{ marginRight: 12 }}>Descargar Q/R</div>
                            <img src={DownloadDetail} alt="downloadDetail" />
                          </div>
                        </MainButtonReclamos>
                        <MainButtonReclamos
                          className="buttom-claim-register"
                          onClick={() =>
                            history.push("/web/admin/registro-quejas-reclamos")
                          }
                        >
                          Registro Queja/Reclamo
                        </MainButtonReclamos>
                      </DivFlexButton>
                    </>
                  )}
                </DivFlexComplaint>
              </>
            )}
          </FlexJustifyBetween>
        </>
      </div>
      {showModal && (
        <AdminComplaintsDetailSidebar
          hideSidebar={toggleModal}
          complaint={selectedComplaint}
          refreshPage={() => {
            const params = { ...loadComplains.getExecution().params, page: 1 };
            loadComplains.execute(params);
          }}
        />
      )}
      {modalReclamos && (
        <DownloadReportModal
          params={loadComplains.params}
          handleClose={handleClose}
          loadComplains={loadComplains}
        />
      )}
    </div>
  );
};
